window.addEventListener('load', function () {
    const floatingCta = document.getElementById('floating-cta')
    const progressElement = document.querySelector('.progress-bar')

    const halfwayPoint = 50
    const nearTheEnd = 80

    const progressObserver = new ScrollProgress((x, y) => {
        const progressPercentage = y * 100

        if (progressPercentage > halfwayPoint && progressPercentage < nearTheEnd) {
            floatingCta.classList.remove('d-none')
        } else {
            floatingCta.classList.add('d-none')
        }

        progressElement.style.width = `${progressPercentage}%`
    })
})
